import React from "react";
import ProjectCard from "./components/ProyectCard/ProjectCard";
import Landing from "../../assets/videos/Landing-pages.mp4";
import LandingMobile from "../../assets/videos/Landing-pages-mobile.mp4";
import LandingTablet from "../../assets/videos/Landing-pages-tablet.mp4";
import SistemaNails from "../../assets/videos/Sistema-nails.mp4"
import SistemaNailsMobile from "../../assets/videos/Sistema-nails-mobile.mp4";
import SistemaNailsTabler from "../../assets/videos/Sistema-nails-tablet.mp4";
import CRM from "../../assets/videos/CRM.mp4";
import CRMMobile from "../../assets/videos/CRM-mobile.mp4";
import CRMTablet from "../../assets/videos/CRM-tablet.mp4";
import IA from "../../assets/videos/IA-pc.mp4";
import IATablet from "../../assets/videos/IA-tablet.mp4";
import IAMobile from "../../assets/videos/IA-mobile.mp4";
import { Badge, Container, Description, Grid, Header, Title, Wrapper } from "./styles";

const Project = () => {
    return (
        <Container id="projects">
            <Wrapper>
                <Header>
                    <Badge>
                        Proyectos
                    </Badge>

                    <Title>
                        Software que genera resultados
                    </Title>

                    <Description>
                        Descubre algunos de los proyectos que hemos desarrollado
                        para negocios que buscan optimizar procesos, mejorar la
                        experiencia de sus usuarios y acelerar su crecimiento.
                    </Description>
                </Header>
                
                <Grid>
                    <ProjectCard 
                        video={{
                            desktop: CRM,
                            tablet: CRMTablet,
                            mobile: CRMMobile,
                        }}
                        title="Sistema de Registro de Clientes Potenciales"
                        description="Plataforma para registrar, administrar 
                        y dar seguimiento a clientes potenciales desde un solo
                        lugar mediante un panel intuitivo y organizado."
                        features={[
                            "Registro de clientes",
                            "Seguimiento de prospectos",
                            "Búsqueda rápida"
                        ]}
                        link={"https://wa.me/5213316710897?text=Hola%2C%20me%20interesa%20conocer%20m%C3%A1s%20sobre%20su%20servicio%20de%20CRM.%20%C2%BFPodr%C3%ADan%20comunicarse%20conmigo%20para%20brindarme%20m%C3%A1s%20informaci%C3%B3n%3F"}
                    />

                    <ProjectCard 
                        video={{
                            desktop: SistemaNails,
                            tablet: SistemaNailsTabler,
                            mobile: SistemaNailsMobile,
                        }}
                        title="Sistema de Gestión de Citas"
                        description="Sistema para la administración de citas y horarios
                        de un salón de belleza, barbería, consultorio, etc.
                        Permitiendo una gestión eficiente de reservas."
                        features={[
                            'Agenda inteligente',
                            'Confirmacion de citas',
                            'Panel administrativo'
                        ]}
                        link={"https://nails-front.netlify.app/"}
                    />

                    <ProjectCard 
                        video={{
                            desktop: Landing,
                            tablet: LandingTablet,
                            mobile: LandingMobile,
                        }}
                        title="Sitio Web Corporativo"
                        description="Sitio Web moderno diseñado para presentar servicios,
                        fortalecer la presencia digital y facilitar el contacto con clientes potenciales."
                        features={[
                            'Diseño moderno',
                            'SEO optimizado',
                            'Contacto por WhatsApp'
                        ]}
                        link={"https://rentadetrajesmr.com/"}
                    />

                    <ProjectCard 
                        video={{
                            desktop: IA,
                            tablet: IATablet,
                            mobile: IAMobile,
                        }}
                        title="IA Generativa"
                        description="Generación de contenido impulsado con IA"
                        features={[
                            'Generación de contenido',
                            'Texto e imágenes',
                            'Propmts personalizados',
                        ]}
                        link={"https://wa.me/5213316710897/?text=Hola%2C%20me%20interesa%20el%20servicio%20de%20IA%20Generativa. %20%C2%BFPodr%C3%ADan%20brindarme%20m%C3%A1s%20informaci%C3%B3n%3F"}
                    />
                </Grid>
            </Wrapper>
        </Container>
    )
};

export default Project;